<template>
  <v-navigation-drawer
    :value="showDrawer"
    temporary
    fixed
    right
    width="500"
    :disable-route-watcher="true"
    stateless
  >
    <template v-slot:prepend>
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title class="text-h6">{{drawerTitle}}</v-list-item-title>
          <v-list-item-subtitle>{{drawerSubtitle}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-divider></v-divider>
    <v-form ref="form" v-model="formFieldsValid" lazy-validation>
      <v-list dense>
        <v-list-item
          v-for="item in rivenditoreItems"
          :key="item.label"
        >
          <v-list-item-content>
            <v-list-item-title>
              <component :is="'p' + item.type" :item="item" @change="componentValueChange" :disabled="readOnly"/>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-form>
    <template v-slot:append>
      <v-container fluid>
        <v-row align="center">
          <v-col class="d-flex justify-space-around" cols="12" sm="6" v-if="!readOnly">
            <v-btn color="success mb-2" @click="onSalva">Salva</v-btn>
          </v-col>
          <v-col class="d-flex justify-space-around" cols="12" sm="6">
            <v-btn color="secondary mb-s" @click="onAnnulla" >{{annullaTitle}}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </v-navigation-drawer>
</template>

<script>
import * as dot from 'dot-object'
import _ from 'lodash'
import configurazioni from '@/services/backofficeService'
import pTesto from '@/views/drawer/elementi/testo'
// import pMultiselect from '@/views/drawer/elementi/multiselect'
import pSwitch from '@/views/drawer/elementi/switch'

export default {
  components: {
    pTesto,
    // pMultiselect,
    pSwitch
  },
  data: () => ({
    backoffice: null,
    show: false,
    locRivenditore: null,
    formFieldsValid: true,
    boRivenditori: [
      {
        model: 'codice',
        valueField: 'codice',
        label: 'Codice',
        type: 'Testo',
        required: true,
        maxlength: 30,
        nospaces: true,
        setristretto: true
      },
      {
        model: 'ragioneSociale',
        valueField: 'ragioneSociale',
        label: 'Ragione sociale',
        type: 'Testo',
        required: true
      }]
  }),
  async mounted() {
    this.backoffice = await configurazioni.getConfigurazione('backoffice', 'pagine')
  },
  watch: {
    rivenditore(value) {
      this.locRivenditore = value
    }
  },
  computed: {
    showDrawer() {
      return this.$store.getters.rightDrawer
    },
    readOnly() {
      return this.$store.getters.rightDrawerReadOnly
    },
    drawerTitle() {
      if (this.readOnly) {
        return 'Visualizza rivenditore'
      } else {
        return this.locRivenditore && this.locRivenditore.codice ? 'Modifica rivenditore' : 'Nuovo rivenditore'
      }
    },
    drawerSubtitle() {
      return this.locRivenditore ? `${this.locRivenditore.codice} - ${this.locRivenditore.ragioneSociale}` : ''
    },
    annullaTitle() {
      return this.readOnly ? 'Chiudi' : 'Annulla'
    },
    rivenditore() {
      return this.$store.getters['rivenditori/rivenditore'] || null // || { codice: '', descrizione: '' }
    },
    rivenditoreItems() {
      if (!this.locRivenditore || !this.backoffice) {
        return []
      }
      const vars = this.backoffice.rivenditori
      const items = []
      for (const item of vars) {
        items.push({value: dot.pick(item.valueField, this.locRivenditore), ...item})
      }
      return items
    }
  },
  methods: {
    componentValueChange(data) {
      const { model, subModel, value } = data
      let tgt = {}
      if (subModel) {
        dot.str(model, value[subModel], tgt)
      } else {
        dot.str(model, value, tgt)
      }
      _.merge(this.locRivenditore, tgt)
    },
    onAnnulla() {
      this.$refs.form.reset()
      this.$store.commit('SET_RIGHT_DRAWER', false)
      this.$store.commit('rivenditori/SET_REFRESH')
    },
    onSalva() {
      const valid = this.$refs.form.validate()
      if (valid) {
        this.$store.commit('rivenditori/SET_RIVENDITORE', this.locRivenditore)
        this.$store.commit('rivenditori/SET_RIVENDITORE_SAVED')
      }
    }
  }
}
</script>